import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import DSDropdownMenu from '@elliemae/ds-dropdownmenu';
import DSButton from '@elliemae/ds-basic/Button';
import { PopperPositions } from '@elliemae/ds-basic/Popper';
import { Menu, MenuCombobox } from '@elliemae/ds-menu';
import SearchSmall from '@elliemae/ds-icons/SearchSmall';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function TextFilterMenu(_ref) {
  var column = _ref.column,
      _ref$menuStyle = _ref.menuStyle,
      menuStyle = _ref$menuStyle === void 0 ? {} : _ref$menuStyle,
      className = _ref.className,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      _ref$isMenuOpened = _ref.isMenuOpened,
      isMenuOpened = _ref$isMenuOpened === void 0 ? false : _ref$isMenuOpened,
      _ref$onOpenMenu = _ref.onOpenMenu,
      onOpenMenu = _ref$onOpenMenu === void 0 ? function () {
    return null;
  } : _ref$onOpenMenu,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? PopperPositions.BOTTOM_END : _ref$placement,
      _ref$menuProps = _ref.menuProps,
      menuProps = _ref$menuProps === void 0 ? {} : _ref$menuProps,
      _ref$onAddFilter = _ref.onAddFilter,
      onAddFilter = _ref$onAddFilter === void 0 ? function () {
    return null;
  } : _ref$onAddFilter,
      _ref$onRemoveFilter = _ref.onRemoveFilter,
      onRemoveFilter = _ref$onRemoveFilter === void 0 ? function () {
    return null;
  } : _ref$onRemoveFilter,
      _ref$maxOptions = _ref.maxOptions,
      maxOptions = _ref$maxOptions === void 0 ? 10 : _ref$maxOptions,
      _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti;

  var options = menuProps.options,
      otherMenuProps = _objectWithoutProperties(menuProps, ["options"]);

  var generateOption = function generateOption(option, idx) {
    return /*#__PURE__*/React.createElement(Menu.ItemCheckbox, {
      key: idx,
      label: option.label,
      name: option.id
    });
  };

  var renderOptions = function renderOptions(arr) {
    return arr.map(generateOption);
  };

  var filtersForColumn = filters.filter(function (f) {
    return f.group === column.property;
  });
  var initialSelectedOptions = filtersForColumn.map(function (f) {
    return f.value;
  });

  var _useState = useState(initialSelectedOptions),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  React.useEffect(function () {
    var filtersForColumn2 = filters.filter(function (f) {
      return f.group === column.property;
    });
    setSelected(filtersForColumn2.map(function (f) {
      return f.value;
    }));
  }, [filters]);
  var filterGroup = column.searchBy || column.property;

  var onCloseMulti = function onCloseMulti() {
    var nextFilters = _toConsumableArray(filters);

    var shouldRemove = []; // if selected doesn't includes item, then we have to remove the filter
    // but given that we are maintaining state here and updating the grid state
    // is not implemented on useFilterableState, we have to do this in 2 traverses
    // as doing it in one gives trouble when removing and adding at the same time.

    initialSelectedOptions.forEach(function (item) {
      if (!selected.includes(item)) {
        nextFilters = nextFilters.filter(function (filter) {
          return !(filter.group === filterGroup && filter.value === item);
        });
        shouldRemove.push({
          group: filterGroup,
          pill: {
            value: item
          }
        });
      }
    });
    shouldRemove.forEach(function (removedFilter) {
      onRemoveFilter(_objectSpread(_objectSpread({}, removedFilter), {}, {
        nextFilters: nextFilters
      }));
    });
    selected.forEach(function (item) {
      // if initialSelectedOptions includes item, then we do nothing
      if (!initialSelectedOptions.includes(item)) {
        var _column$filter;

        onAddFilter({
          group: filterGroup,
          label: column.label,
          value: item,
          operator: (column === null || column === void 0 ? void 0 : (_column$filter = column.filter) === null || _column$filter === void 0 ? void 0 : _column$filter.operator) || 'contains',
          transformRowValue: column.valueTransformation
        }, column);
      }
    });
    onClose();
  };

  return /*#__PURE__*/React.createElement(DSDropdownMenu, {
    closeMenuOnItemSelection: true,
    contentStyle: menuStyle,
    customMenu: isMulti ? /*#__PURE__*/React.createElement(Menu, {
      containerProps: {
        id: 'text-filter-menu-multiple'
      },
      className: "dg-multiple-filter",
      visible: true
    }, /*#__PURE__*/React.createElement(Menu.SelectionGroup, {
      active: selected,
      onSelect: function onSelect(newValues) {
        setSelected(newValues);
      },
      focusOnOpen: true,
      multi: true,
      searchable: true
    }, renderOptions(options))) : /*#__PURE__*/React.createElement(MenuCombobox, _extends({}, otherMenuProps, {
      className: className,
      dropdownFilterOptions: _objectSpread(_objectSpread({}, column.dropdownFilterOptions), {}, {
        maxOptions: maxOptions
      }),
      maxWidth: column.filterMenuMaxWidth,
      minWidth: column.filterMenuMinWidth,
      onSelectMenuItem: function onSelectMenuItem(selectedValue) {
        if (selectedValue) {
          var _column$filter2;

          onAddFilter({
            group: column.searchBy || column.property,
            label: column.label,
            value: selectedValue,
            operator: (column === null || column === void 0 ? void 0 : (_column$filter2 = column.filter) === null || _column$filter2 === void 0 ? void 0 : _column$filter2.operator) || 'contains',
            transformRowValue: column.valueTransformation
          }, column);
          onOpenMenu(false);
        }
      }
    })),
    isOpen: isMenuOpened,
    maxWidth: column.filterMenuMaxWidth,
    menuProps: menuProps,
    minWidth: column.filterMenuMinWidth,
    onOpenMenu: onOpenMenu,
    onClose: isMulti ? onCloseMulti : onClose,
    options: compact(options),
    placement: placement,
    triggerComponent: /*#__PURE__*/React.createElement(DSButton, {
      buttonType: "text",
      icon: /*#__PURE__*/React.createElement(SearchSmall, null),
      onClick: function onClick() {
        return isMenuOpened ? onOpenMenu(false) : onOpenMenu(true);
      },
      size: "s"
    })
  });
}

TextFilterMenu.propTypes = {
  column: PropTypes.any,
  menuStyle: PropTypes.shape({}),
  className: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  isMenuOpened: PropTypes.bool,
  onOpenMenu: PropTypes.func,
  onClose: PropTypes.func,
  placement: PropTypes.string,
  menuProps: PropTypes.shape({}),
  onAddFilter: PropTypes.func,
  onRemoveFilter: PropTypes.func,
  maxOptions: PropTypes.number,
  isMulti: PropTypes.bool
};

export default TextFilterMenu;
//# sourceMappingURL=TextFilterMenu.js.map
